const EDITOR_LISTS_SCHEMA = new WeakMap();
export function register(editor, schema) {
  EDITOR_LISTS_SCHEMA.set(editor, schema);
}
export function unregister(editor) {
  EDITOR_LISTS_SCHEMA.delete(editor);
}
export function has(editor) {
  return EDITOR_LISTS_SCHEMA.has(editor);
}
export function get(editor) {
  const schema = EDITOR_LISTS_SCHEMA.get(editor);
  if (!schema) {
    throw new Error('This editor instance does not have a ListsSchema associated. Make sure you initialize it with withLists() before using ListsEditor functionality.');
  }
  return schema;
}